import React from "react";
import classNames from "classnames";

const Arrow: React.FC<{ direction?: "down" | "up" | undefined }> = ({ direction = undefined }) => {
  return direction ? <i className={classNames("arrow ml-2", direction)}></i> : <i></i>;
};

export default Arrow;
